import {useContext, useMemo} from "react";
import context from "components/Shared/MSidebar/utility/context";

const useTo = path => {
  const {pathname} = useContext(context);
  const to = useMemo(
    () => path 
      ? (pathname === "/" && path === "/") 
        ? "/refresh"
        : path
      : "",
    [pathname]
  );
  return to;
};

export default useTo;